import { User } from './../objects/real-time';
import {Injectable} from '@angular/core';
import 'rxjs/add/operator/map';
import {Observable} from 'rxjs/Observable';
import { Http , Response,Headers, RequestOptions} from '@angular/http';
import {Groupe,Vehicule,VehiculeGetDTO,GroupAddDTO} from '../objects/index';
import {GlobalService} from "./global.config";
import {createAuthorizationHeader} from "../utils/headers";
import {Events } from 'ionic-angular';

@Injectable()
export class GroupService {
    currentuser:User;
    dns:string;
   constructor(private _http: Http,private globalService : GlobalService,public events: Events ) {
        this.currentuser=JSON.parse(localStorage.getItem('currentuser'));
       this.dns = globalService.getDns();
        console.log(this.dns);
    }
public toastyAdd:Boolean=false;
public toastyUpdate:Boolean=false;
public groups:Groupe[]=[];
vehiculeLabels:VehiculeGetDTO[]=[];
public bigCurrentPage:number = 1;



      getGroupsByPageAndSize(page:number,size:number): Observable<any> {
                let headers = new Headers({'Accept': 'application/json'});
                headers.append('Authorization', this.currentuser.token);
        return this._http.get(this.dns +'groupes/list'+'?page='+page+'&size='+size, {headers: headers}).map(res => res.json());
    }
 
      getVehiculesMatricules(): Observable<VehiculeGetDTO[]> {
                let headers = new Headers({'Accept': 'application/json'});
                headers.append('Authorization', this.currentuser.token);
        return this._http.get(this.dns+'vehicules/minify', {headers: headers}).map(res => res.json());
    }

   getVehiculesGroup(id:number): Observable<VehiculeGetDTO[]> {
            let headers = new Headers({'Accept': 'application/json'});
            headers.append('Authorization', this.currentuser.token);
            return this._http.get(this.dns+'groupes/vehicules/'+id, {headers: headers}).map(res => res.json());
    }

   addGroup(groupDto: GroupAddDTO): Observable<Groupe> {
                let headers = new Headers({'Content-Type': 'application/json'});
                headers.append('Authorization', this.currentuser.token);
        let options = new RequestOptions({headers: headers});
        let body = JSON.stringify(groupDto);
    return this._http.post(this.dns+'groupes/',groupDto, options).map(res => res.json());
    }

    deleteGroupById(id:number): Observable<Boolean> {
              let headers = new Headers({'Accept': 'application/json'});
              headers.append('Authorization', this.currentuser.token);
              return this._http.delete(this.dns+'groupes/'+id, {headers: headers}).map(res => res.json());
    }
     
    public putGroupDTO(groupDto:GroupAddDTO): Observable<Groupe> {
            let headers = new Headers({'Content-Type': 'application/json'});
            headers.append('Authorization', this.currentuser.token);
            let options = new RequestOptions({headers: headers});
        let body = JSON.stringify(groupDto);
    return this._http.put(this.dns+'groupes/', groupDto, options).map(res => res.json());
                                                                 }                                                                
getGroup(idGroupe: number){
  return this.groups.find(group => group.idGroupe === idGroupe);
}

 getOne(idGroup): Observable<Groupe> {
          let headers = new Headers({'Accept': 'application/json'});
          headers.append('Authorization', this.currentuser.token);
          return this._http.get(this.dns+'groupes/'+idGroup, {headers: headers}).map(res => res.json());
    }

}




// WEBPACK FOOTER //
// ./src/providers/group.service.ts